import { apiGetCoinById } from '@/Groups/CoinTooltip/private/api/getCoinData';

const CoinTooltip = {
  namespaced: true,

  state: {
    data: null,
    isOpen: false,
    isLoading: false,
    isReady: false,
  },

  actions: {
    async init({ state, commit }, coin){
      if(state.isLoading || state.isReady) return;
      const data = await apiGetCoinById(coin)
      commit('SET_DATA', data);
      commit('SET_LOADING', true);
      commit('SET_READY', true);
      console.log(coin);
    },

    async toggleOpenedFlag({ commit }, status){
      commit('TOGGLE_OPENED_FLAG', status);
    },

    async closeTooltip({ state, commit }){
      if(!state.isOpen) return;
      commit('TOGGLE_OPENED_FLAG', false);
      commit('SET_LOADING', false);
      commit('SET_READY', false);
      commit('SET_DATA', null);
    }
  },

  mutations: {
    TOGGLE_OPENED_FLAG(state, status){
      state.isOpen = status;
    },
    SET_LOADING(state, status) {
      state.isLoading = status;
    },
    SET_READY(state, status) {
      state.isReady = status;
    },
    SET_DATA(state, data){
      state.data = data;
    }
  },  

  getters: {  
    getData: (state) => state.data,
    getIsLoading: (state) => state.isLoading,
    getIsReady: (state) => state.isReady,
    getIsOpen: (state) => state.isOpen,
  },
}

export default CoinTooltip;